export const DOMAIN = 'litigationDetails';
